// Готує офлайн-базу ОДРАЗУ після входу: качає пакет питань + УСІ картинки з видимим
// прогресом (як у конкурентів), і зливає чергу проходжень при поверненні мережі.
// Блокуючий екран показуємо, поки база не готова ПОВНІСТЮ (питання + картинки), щоб
// офлайн одразу працював і люди не мусили «чекати у фоні».
import { useEffect, useRef, useState } from 'react';
import {
  offlineBootstrap,
  initOfflineListeners,
  isOfflineReady,
  type DownloadProgress,
} from '../lib/offlineSync';
import { isNativeApp } from '../lib/push';

export function OfflineBootstrap() {
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState<DownloadProgress | null>(null);
  const [canSkip, setCanSkip] = useState(false);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    // Офлайн-базу качаємо ЛИШЕ в нативному Android-додатку. У Telegram Mini App і
    // браузері користувач завжди онлайн — там качати нічого не треба (і не заважаємо).
    if (!isNativeApp()) return;
    initOfflineListeners();
    void (async () => {
      const ready = await isOfflineReady();
      // Блокуючий екран — лише коли база ще НЕ готова повністю і є мережа
      if (!ready && navigator.onLine) setShow(true);
      // Дозволяємо пропустити через 6 с (раптом поганий зв'язок) — завантаження триває у фоні
      const t = setTimeout(() => setCanSkip(true), 6000);
      await offlineBootstrap((p) => setProgress(p));
      clearTimeout(t);
      setShow(false);
    })();
  }, []);

  if (!show) return null;

  // Єдиний відсоток на все завантаження (без технічних деталей про «зображення»).
  const pct =
    progress?.phase === 'images' && progress.total
      ? Math.round((progress.done / progress.total) * 100)
      : progress?.phase === 'done'
        ? 100
        : progress?.phase === 'pack'
          ? 3
          : 0;

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-tg-bg p-8 text-center">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-tg-secondary-bg border-t-tg-link" />
      <div className="text-base font-semibold text-tg-text">Завантаження питань…</div>
      <div className="h-2 w-60 overflow-hidden rounded-full bg-tg-secondary-bg">
        <div className="h-full bg-tg-link transition-all duration-300" style={{ width: `${pct}%` }} />
      </div>
      <div className="text-sm text-tg-hint">{pct}%</div>
      <div className="max-w-xs text-xs text-tg-hint">
        Готуємо базу, щоб тести працювали без інтернету. Це разово — далі відкриватиметься миттєво.
      </div>
      {canSkip && (
        <button
          onClick={() => setShow(false)}
          className="mt-2 text-xs text-tg-link underline-offset-4 hover:underline"
        >
          Пропустити (докачається у фоні)
        </button>
      )}
    </div>
  );
}
